import { useMemo } from "react";

export default function GlassLoader() {
  const message = useMemo(() => {
    const day = new Date().getDay();

    const messages = [
      "Ребята, я знаю, что у вас выходной, но тут в чате всё сломалось, что делать? Я вообще туда это пишу? Ребята?",
      "В связи с тем, что сотрудники не желают работать в понедельник, время загрузки увеличено",
      "Ну вот, наконец-то всё стабильно работает",
      "Вот черт, наш сервер убежал. Отправьте сотрудников на ловлю и скажите Алексу, что делать живой сервер было плохой идеей",
      "В очередной раз [ДАННЫЕ УДАЛЕНЫ] порвало все провода. Отправьте [ ██████ ] устранять проблему. Сегодня его смена",
      "Внимание всем: сервер разозлился! Код красный! Бегите",
      "Кто разрешил суккубу регистрироваться? Закрываем всё, пока дети не увидели"
    ];

    return messages[day];
  }, []);

  return (
    <div style={styles.overlay}>
      <div style={styles.card}>
        <div style={styles.shimmer} />

        {/* 🔥 ТЕКСТ В ЦЕНТРЕ */}
        <div style={styles.textBox}>
          {message}
        </div>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    background: "rgba(20,20,20,0.6)",
    backdropFilter: "blur(12px)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 99999
  },

  card: {
    width: 260,
    height: 320,
    borderRadius: 20,
    background: "rgba(255,255,255,0.05)",
    border: "1px solid rgba(255,255,255,0.1)",
    position: "relative",
    overflow: "hidden",

    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 20
  },

  shimmer: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(120deg, transparent 20%, rgba(255,255,255,0.08) 50%, transparent 80%)",
    backgroundSize: "200% 100%",
    animation: "glassShimmer 1.5s infinite"
  },

  textBox: {
  position: "relative",
  zIndex: 2,

  color: "#eaeaea",
  fontSize: 14,
  lineHeight: 1.5,
  textAlign: "center",

  padding: "0 10px", // чтобы текст не прилипал к краям
  maxWidth: "100%"
}
};